import React from 'react';

const ClockIcon: React.FC = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6491 13.431L9.55334 10.5631L9.54834 10.5625V5.5H11.7983V9.38832L14.9396 11.5879L13.6491 13.431Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.6733 19C15.6439 19 19.6733 14.9706 19.6733 10C19.6733 5.02944 15.6439 1 10.6733 1C5.70278 1 1.67334 5.02944 1.67334 10C1.67334 14.9706 5.70278 19 10.6733 19ZM10.6733 3.1375C14.4634 3.1375 17.5358 6.20995 17.5358 10C17.5358 13.7901 14.4634 16.8625 10.6733 16.8625C6.88329 16.8625 3.81084 13.7901 3.81084 10C3.81896 6.21331 6.88665 3.14562 10.6733 3.1375Z"
        fill="white"
      />
    </svg>
  );
};

export default ClockIcon;
